import {
  createContext,
  Fragment,
  useContext,
  useEffect,
  useState,
} from "react";
import {
  Box,
  Button,
  Icon,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Checkbox,
  FormControlLabel,
  Stack,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import BASEURL from "../../Utils/Baseurl";
import request, { gql } from "graphql-request";
import MaterialBox from "../../../components/MaterialBox";
import SignInInput from "../../../components/SignInInput";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import MaterialLoadingButton from "../../../components/MaterialLoadingButton";
import ConfirmationDialog from "../../../components/Dialog/ConfirmationDialog";
import axios from "axios";
import { useUserDetails } from "../../../context/auth";
import { setUserGroup, useMaterialUIController } from "../../../context";
import CryptoJS from "crypto-js"; // Import crypto-js
import "../login.css";
import LogInLayout from "../../../layout/LogInLayout";
import EverGuardLoginLayout from "../../../layout/EverGuardLoginLayout";
import assestsConfig from '../../../config/assestsConfig'

const isEverGuard = ["eg", "everguard"].includes(
  String(assestsConfig.company).trim().toLowerCase()
);
const ActiveLoginLayout = isEverGuard ? EverGuardLoginLayout : LogInLayout;

const UserDetailsContext = createContext();

function Signin() {
  const navigate = useNavigate();
  const { setAccessData, updatingUser } = useUserDetails();
  const SECRET_KEY = "my_secret_key_123";
  const [controller, dispatch] = useMaterialUIController();
  const [rememberMe, setRememberMe] = useState(false);
  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });
  const [signInData, setSignInData] = useState({
    email: "",
    password: "",
    viewPassword: false,
    newPassword: "",
    viewNewPassword: false,
    confirmPassword: "",
    viewConfirmPassword: false,
    emailStatus: "unchecked",
    passwordStatus: "unchecked",
    newPasswordStatus: "unchecked",
    confirmPasswordStatus: "unchecked",
  });
  const [user, setUser] = useState({
    name: "",
    userName: "",
    email: "",
    picture: "",
    token: "",
    details: "",
  });
  const [stage, setStage] = useState("sign-in");

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    customSection: null,
    onConfirm: () => { },
    onCancel: () => { },
  });
  const keydownHandler = (event) => {
    console.log("hh", event);
    if (event.key === "Enter") {
      handleSignIn();
    }
  };

  useEffect(() => {
    setPageState((prevState) => ({ ...prevState, state: "default" }));
  }, []);

  const LOGIN = gql`
    mutation User_Login($email: String!, $password: String!) {
      userLogin(email: $email, password: $password) {
        detail
        access
        message
        success
        error
      }
    }
  `;

  const handleSignIn = async () => {
    const { email, password } = signInData;
    setPageState({
      ...pageState,
      loading: true,
    });

    try {
      const response = await request(BASEURL, LOGIN, { email, password });
      console.log("responseuser:", response);
      // let Name = response.userLogin.detail.first_name;

      if (response.userLogin.success) {
        // sessionStorage.setItem("token", JSON.stringify(response.userLogin.token));
        sessionStorage.setItem("is_auth", JSON.stringify("true"));
        // const userDetails = {
        //   ...response.userLogin.detail,
        //   gender: 'Female',
        //   MaritalStatus: 'UnMarried',
        // };

        // sessionStorage.setItem("user", JSON.stringify(userDetails));
        sessionStorage.setItem(
          "user",
          JSON.stringify(response.userLogin.detail,)
        );
        sessionStorage.setItem(
          "access",
          JSON.stringify(response.userLogin.access)
        );
        setUserGroup(dispatch, response.userLogin);

        setUser({
          ...user,

          name:
            response.userLogin.detail.firstName +
            " " +
            response.userLogin.detail.lastName,
          userName: response.userLogin.detail.username,
          email: response.userLogin.detail.email,
          // picture: response.userLogin.user.picture,
          // token: response.userLogin.token,
          details: response.userLogin.detail,
        });
        updatingUser();

        setTimeout(() => {
          navigate("/dashboard");
        }, 2000);
      } else {
        sessionStorage.setItem("token", "undefined");
        sessionStorage.setItem("user", "undefined");
        setPageState({
          ...pageState,
          loading: false,
          error: true,
          title: "Error message",
          message: response?.userLogin?.message,
          state: "default",
        });
      }
    } catch (error) {
      console.log("error:", error);

      sessionStorage.setItem("token", "undefined");
      sessionStorage.setItem("user", "undefined");
      setPageState({
        ...pageState,
        loading: false,
        error: true,
        title: "Error message",
        message: "An error occurred. Please try again.",
        state: "default",
      });
    }
  };

  const handleConfirmPassword = async () => {
    const query = `mutation ChangePassword(
        $token: String!
        $newPassword1: String!
        $newPassword2: String!
        ) {
        passwordReset(
        token: $token
        newPassword1: $newPassword1
        newPassword2: $newPassword2
        ) {
            success
            errors
        }
        } `;
    try {
      const response = await axios({
        url: BASEURL,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          query,
          variables: {
            // token: token,
            newPassword1: signInData.newPassword,
            newPassword2: signInData.confirmPassword,
          },
        }),
      });

      navigate("/sign-in");
    } catch (error) {
      console.error("responseError:", error);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const handleForgotPassword = async () => {
    const { email } = signInData;
    const query = `

    mutation password_reset_mutation($email: String!){
  resetPasswordMail(email:$email){
    message
    success
    error
  }
}
  `;

    try {
      const response = await axios({
        url: BASEURL,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          query,
          variables: {
            email: email,
          },
        }),
      });

      console.log("reset response:", response);
      // sessionStorage.setItem("newPasswordToken", JSON.stringify(token));
      setStage("forgot-password");
    } catch (error) {
      console.error("responseError:", error);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const handlePasswordVisibility = () => {
    setSignInData((prevState) => ({
      ...prevState,
      viewPassword: !prevState.viewPassword,
    }));
  };

  const handleSigninChange = (event) => {
    const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,6}$/g;
    const lowerCaseRegex = /^(?=.*[a-z])/;
    const upperCaseRegex = /^(?=.*[A-Z])/;
    const numberRegex = /^(?=.*[0-9])/;
    const specialCharacterRegex = /^(?=.*[@$!%*?&])/;
    const lengthRegex = /([a-zA-Z0-9@$!%*?&]{3,8})$/;

    let signInState = { ...signInData };
    if (event.target.name === "email") {
      if (emailRegex.test(event.target.value) === true) {
        signInState.emailStatus = "success";
      } else {
        signInState.emailStatus = "error";
      }
      signInState[event.target.name] = event.target.value;
    } else if (event.target.name === "password") {
      if (
        // lowerCaseRegex.test(event.target.value) &&
        // upperCaseRegex.test(event.target.value) &&
        // numberRegex.test(event.target.value) &&
        // specialCharacterRegex.test(event.target.value) &&
        lengthRegex.test(event.target.value) === true
      ) {
        signInState.passwordStatus = "success";
      } else {
        signInState.passwordStatus = "error";
      }
      signInState[event.target.name] = event.target.value;
    } else if (event.target.name === "newPassword") {
      signInState.newPasswordStatus =
        lowerCaseRegex.test(event.target.value) &&
          upperCaseRegex.test(event.target.value) &&
          numberRegex.test(event.target.value) &&
          specialCharacterRegex.test(event.target.value) &&
          lengthRegex.test(event.target.value)
          ? "success"
          : "error";
      signInState.confirmPasswordStatus =
        signInState.confirmPassword === event.target.value
          ? "success"
          : "error";
    } else if (event.target.name === "confirmPassword") {
      signInState.confirmPasswordStatus =
        signInState.newPassword === event.target.value ? "success" : "error";
    }
    signInState[event.target.name] = event.target.value;
    setSignInData(signInState);
  };

  const baseStyles = {
    // Styles that apply to all screen sizes
    container: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "100vh",
      fontFamily: "'Poppins', sans-serif",
      backgroundColor: "#f8f9fa",
    },
    card: {
      display: "flex",
      flexDirection: "row-reverse",
      width: "800px",
      maxWidth: "90%",
      height: "450px",
      background: "#fff",
      borderRadius: "15px",
      boxShadow: "0 8px 16px rgba(0, 0, 0, 0.1)",
      overflow: "hidden",
    },
    leftSection: {
      padding: "30px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
    },
    rightSection: {
      flex: 1,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "#e7f0fe",
      height: "100%",
    },
    image: {
      width: "93%",
      height: "100%",
      objectFit: "contain",
      display: "block",
    },
    title: {
      fontSize: "18px",
      fontWeight: "bold",
      color: "#002c8c",
      marginBottom: "10px",
    },
    inputGroup: {
      width: "100%",
      marginBottom: "15px",
      position: "relative",
    },
    inputField: {
      width: "100%",
      padding: "12px 40px",
      fontSize: "1rem",
      border: "1px solid #ced4da",
      borderRadius: "8px",
      outline: "none",
      transition: "border-color 0.3s ease",
      boxSizing: "border-box",
    },
    inputFieldFocus: {
      borderColor: "#80bdff",
      boxShadow: "0 0 0 0.2rem rgba(0, 123, 255, 0.25)",
    },
    inputIcon: {
      position: "absolute",
      left: "10px",
      top: "50%",
      transform: "translateY(-50%)",
      color: "#aaa",
      pointerEvents: "none",
    },
    loginButton: {
      width: "100%",
      padding: "12px",
      fontSize: "1rem",
      color: "#fff",
      background: "#007bff",
      border: "none",
      borderRadius: "8px",
      cursor: "pointer",
      marginTop: "15px",
      transition: "background 0.3s ease",
    },
    loginButtonHover: {
      background: "#0069d9",
    },
    forgotPassword: {
      color: "#007bff",
      textDecoration: "none",
      marginTop: "10px",
      fontSize: "0.9rem",
      display: "block",
      textAlign: "center",
    },
    rememberMeContainer: {
      display: "flex",
      alignItems: "center",
      marginBottom: "15px",
      fontSize: "0.9rem",
      color: "#343a40",
    },
    rememberMeCheckbox: {
      marginRight: "5px",
    },
  };

  const styles = {
    ...baseStyles, // Spread the base styles

    "@media (max-width: 768px)": {
      // Media query at the top level
      ...baseStyles, // Apply base styles first
      card: {
        flexDirection: "column-reverse",
        height: "auto",
      },
      rightSection: {
        display: "none",
        flex: 0,
      },
      leftSection: {
        flex: 1,
        padding: "20px",
      },
      title: {
        fontSize: "20px",
        marginBottom: "10px",
      },
      inputField: {
        padding: "10px 35px",
      },
      loginButton: {
        marginTop: "1px",
      },
    },
  };

  const encryptData = (data) => {
    return CryptoJS.AES.encrypt(data, SECRET_KEY).toString();
  };

  // Decrypt function
  const decryptData = (encryptedData) => {
    try {
      const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
      return bytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      return "";
    }
  };

  // Load stored credentials if "Remember Me" was checked
  useEffect(() => {
    const storedEmail = localStorage.getItem("rememberedEmail");
    const storedPassword = localStorage.getItem("rememberedPassword");
    const storedRememberMe = localStorage.getItem("rememberMe") === "true";

    if (storedEmail && storedPassword && storedRememberMe) {
      setSignInData((prev) => ({
        ...prev,
        email: decryptData(storedEmail),
        password: decryptData(storedPassword),
        emailStatus: "success",
        passwordStatus: "success",
      }));
      setRememberMe(true);
    }
  }, []);

  // Handle "Remember Me" functionality
  const handleRememberMeChange = () => {
    setRememberMe(!rememberMe);
    if (!rememberMe) {
      localStorage.setItem("rememberedEmail", encryptData(signInData.email));
      localStorage.setItem(
        "rememberedPassword",
        encryptData(signInData.password)
      );
      localStorage.setItem("rememberMe", "true");
    } else {
      localStorage.removeItem("rememberedEmail");
      localStorage.removeItem("rememberedPassword");
      localStorage.removeItem("rememberMe");
    }
  };

  return (
    <UserDetailsContext.Provider value={user}>
      <ActiveLoginLayout title={assestsConfig.loginname} subtitle=" ">
        {confirmationDialog.open && (
          <ConfirmationDialog
            open={confirmationDialog.open}
            title={confirmationDialog.title}
            message={confirmationDialog.message}
            showCancel={confirmationDialog.showCancel}
            showConfirm={confirmationDialog.showConfirm}
            customSection={confirmationDialog.customSection}
            onConfirm={confirmationDialog.onConfirm}
            onCancel={confirmationDialog.onCancel}
          />
        )}

        {pageState.error && (
          <Dialog maxWidth="sm" open={pageState.error} fullWidth>
            <DialogTitle>
              <Typography variant="body1">{pageState.title}</Typography>
            </DialogTitle>
            <DialogContent variant="body2">{pageState.message}</DialogContent>
            <DialogActions>
              <Button
                color="error"
                variant="text"
                onClick={() =>
                  setPageState((prevState) => ({
                    ...prevState,
                    error: false,
                  }))
                }
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>
        )}
        <MaterialBox component="form" role="form" mt={1}>
          <Stack className="login-fields" direction={"column"} spacing={2}>
            <SignInInput
              label="Work email"
              id="email"
              helperText="Please enter a valid email address"
              onKeyDown={keydownHandler}
              fullWidth
              placeholder="Email"
              name="email"
              variant="outlined"
              size="small"
              value={signInData.email}
              onChange={handleSigninChange}
              error={signInData.emailStatus === "error"}
              disabled={pageState.loading === true}
            />
            <SignInInput
              label="Password"
              id="password"
              helperText="Please enter a valid Password"
              onKeyDown={keydownHandler}
              fullWidth
              placeholder="Password"
              name="password"
              type={signInData.viewPassword ? "text" : "password"}
              variant="outlined"
              value={signInData.password}
              onChange={handleSigninChange}
              error={signInData.passwordStatus === "error"}
              disabled={pageState.loading === true}
              icon={
                signInData.viewPassword
                  ? {
                    direction: "right",
                    component: (
                      <Icon color="action" fontSize="small">
                        <VisibilityOffIcon
                          onClick={handlePasswordVisibility}
                          style={{ cursor: "pointer" }}
                        />
                      </Icon>
                    ),
                  }
                  : {
                    direction: "right",
                    component: (
                      <Icon color="action" fontSize="small">
                        <VisibilityIcon
                          onClick={handlePasswordVisibility}
                          style={{ cursor: "pointer" }}
                        />
                      </Icon>
                    ),
                  }
              }
            />
          </Stack>
          <MaterialBox className="login-options" m={0.5}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={rememberMe}
                  onChange={handleRememberMeChange}
                  color="primary"
                />
              }
              label="Keep me signed in"
            />
            <a href="/forgot-password" style={styles.forgotPassword}>
              Forgot password?
            </a>
          </MaterialBox>
          <Stack direction={"column"} spacing={1}>
            <MaterialBox>
              <MaterialLoadingButton
                variant="gradient"
                color="dark"
                fullWidth
                size="medium"
                loadingPosition="start"
                onClick={() => {
                  if (!pageState.loading) {
                    handleSignIn();
                  }
                }}
                disabled={
                  signInData.emailStatus !== "success" ||
                  signInData.passwordStatus !== "success"
                }
                loading={pageState.loading}
              >
                Sign in to dashboard
              </MaterialLoadingButton>
            </MaterialBox>
          </Stack>
        </MaterialBox>
      </ActiveLoginLayout>

    </UserDetailsContext.Provider>
  );
}

export default Signin;
